export default function getFloatStr(str) {
    if (!str) {
        return str;
    }

    return +str.toString().replace(/,/gi, '.');
}
